import React from "react";
import { withStyles } from '@material-ui/core';


class Teste extends React.Component {
    constructor(props) {
        super(props);

        this.state = { cor: "blue" };
    }

    componentDidMount() {
        console.log("MONTEI " + this.props.id);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        console.log("ATUALIZEI " + this.props.id);

        if(
            prevProps.valor <= 20 &&
            this.props.valor > 20
        ) {
            this.setState( { cor: "red" });
        }
    }

    componentWillUnmount () {
        console.log("DESMONTEI " + this.props.id);
    }

    render(){
        if(this.props.children)
            this.props.children();

        console.log("this.props.children", this.props.children);
        console.log( "RENDERIZOU! " + this.props.id);

        // let x = undefined;
        // x.sayHo();

        return <div style={ ({backgroundColor: this.state.cor, color: "white"}) }>Teste  {this.props.valor}
        ANTES:<br/>
        {this.props.children}
        <br/>DEPOIS!</div>;
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }


    componentDidCatch(error, info) {
        console.log("Catch!", { error, info } )
    }
}

export default Teste;